import angular from 'angular';

export default function JobSchedulerMockService($http, appSettings) {
  'ngInject';
  var accessKeyId = appSettings.SchedulerAWSAccessKey;
  var secretAccessKey = appSettings.SchedulerAWSSecretKey;
  var sqsQueue = appSettings.SchedulerAWSQueueUrl;

  this.createSchedule = function (schedule) {
    const endpoint = appSettings.InReachApiSchedulerEndpoint + '/schedules/';
    let req = {};
    if (schedule) {
      angular.forEach(schedule.data.actions, function (action) {
        action.message.accessKeyId = accessKeyId;
        action.message.secretAccessKey = secretAccessKey;
        action.message.queue = sqsQueue;
      });
      req = {
        method: 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(schedule.data)
      }; //end req
    }

    return $http(req);
  };
}